import(/* webpackMode: "eager" */ "/home/ec2-user/reyner.giovanni/one21-company-site/production/releases/20261103170519/src/app/[type]/[city]/client-page.js")